import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbModal, NgbModalRef, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { IPagedResults } from '../../../core/interfaces';
import { AuthenticationService, IncidentAccidentServiceService, SettingsService } from '../../../services';
import { modalMyClass } from '../../../shared/modules/dialogOptions';
import AgGridUtils from '../../../shared/utilities/ag-grid.utils';
import { IncidentAccidentEditComponent } from '../incident-accident-edit/incident-accident-edit.component';

@Component({
    selector: 'app-incident-accident-list',
    templateUrl: './incident-accident-list.component.html',
    styleUrls: ['./incident-accident-list.component.scss']
})
export class IncidentAccidentListComponent implements OnInit {
    @Output()
    DeleteData = new EventEmitter<any>();
    showSpinner: boolean;
    totalItems: any = 0;
    skadetypes: any = [];
    accidentTypeSelected: number;
    deleteId: any;
    public overlayLoadingTemplate = '<span class="ag-overlay-loading-center"><i style="font-size: 20px;" class="fa fa-spinner fa-spin"><i></span>';
    private moduleId = 30;

    modalReference: NgbModalRef;
    public role: any = {
        Name: '',
        Description: ''
    };

    columnDefs = [
        {
            headerName: "Site",
            field: "SiteName",
            sortable: true,
            //cellRenderer: this.customCellRendererFunc,
            width: 120,
            filter: false,
        },
        {
            headerName: 'Date/Time', field: 'Date', sortable: true, resizable: true,
            width: 120,
            sort: "asc",
            valueFormatter: this.dateFormatterRemindDate, filter: "agDateColumnFilter",
            comparator: function(date1, date2, params) {

                var date1S = params.gridOptionsWrapper.gridOptions.context.componentParent.getDate(date1, params.data.Time);

                var date2S = params.gridOptionsWrapper.gridOptions.context.componentParent.getDate(date2, params.data.Time);

                return date2S - date1S;
            },
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Type', field: 'Group',
            sortable: true,
            cellRenderer: this.customCellRendererFunc,
            width: 150,
            filter: false
        },
        {
            headerName: 'Description', field: 'Event', sortable: true, resizable: true,
            width: 520,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Location', field: 'Location', sortable: true, resizable: true,
            width: 200,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Skadetyp', field: 'Skadetyp',
            sortable: true,
            cellRenderer: this.customCellRendererFuncSkadetyp,
            width: 130,
            filter: false
        },
        {
            headerName: 'Status', field: 'Status',
            sortable: true,
            cellRenderer: this.customCellRendererFuncActionStatus,
            cellClass: "grid-cell-centered",
            width: 80,
            filter: false
        },
        {
            headerName: 'InternalCaseNumber', field: 'InternalCaseNumber', sortable: true, resizable: true,
            width: 220,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },

    ];

    SiteId: number = 0;

    SiteId$ = new BehaviorSubject(this.SiteId);
    gridOptions: GridOptions;
    rowSelection: string;
    timezone: any;
    constructor(private settingService: SettingsService, private incidentAccidentService: IncidentAccidentServiceService, private router: Router, private authenticationService: AuthenticationService,
        private modalService: NgbModal) {

        this.rowSelection = "single";

        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("timezone", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.timezone = response.Data.Value;
                }
            });

    }
    packageData: any = [];
    ngOnInit() {

        this.SiteId$.subscribe((x) => {
            //this.gridApi = params.api; // To access the grids API

            if (this.gridColumnApi) {
                if (x != 0) {
                    this.gridColumnApi.setColumnVisible("SiteName", false);
                } else {
                    this.gridColumnApi.setColumnVisible("SiteName", true);
                }
            }
        });

        this.gridOptions = <GridOptions>{
            context: {
                componentParent: this
            },
            suppressRowClickSelection: true,
            onCellClicked: (e) => {

                if (e.colDef.headerName !== "Action") { // cell is from non-select column

                    e.node.setSelected(true);
                } else {
                    throw "";
                }
            },
            defaultColDef: {
                filter: true // set filtering on for all cols
            },
        };

        this.loadSkadetypes();
    }

    // onSelectionChanged(params) {
    //   // 

    //   // var selectedRowsString = "";
    //   // selectedRows.forEach(function(selectedRow, index) {
    //   //   if (index !== 0) {
    //   //     selectedRowsString += ", ";
    //   //   }
    //   //   selectedRowsString += selectedRow.athlete;
    //   // });
    //   // document.querySelector("#selectedRows").innerHTML = selectedRowsString;
    // }
    onRowClicked(params) {
        //         
        params.context.componentParent.editItem(params.data.Id, params.rowIndex);
    }

    private gridApi;
    private gridColumnApi;
    onGridReady(params) {

        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;


    }
    //SelectedRow: number =0;
    handleScroll(params) {
        // 
        var test = params;
        //  
        //this.SelectedRow = params.data.Id;

    }
    scrollToId() {

        setTimeout(() => {
            if (localStorage.getItem('ScrollToId') != null) {
                var Id = +localStorage.getItem('ScrollToId');
                //this.gridOptions.api.ensureIndexVisible(Number(Id))

            }

            if (localStorage.getItem('selectedRowIncidentAccident') != null) {
                // 
                var IdSelected = +localStorage.getItem('selectedRowIncidentAccident');
                //this.gridOptions.api.ensureIndexVisible(Number(Id))

                this.gridOptions.api.forEachNode((node) => {
                    if (node.data.Id === IdSelected) {
                        // Master open detail.  You could also call node.setSelected( true ); for alternate design.
                        //node.setExpanded(true);
                        this.gridOptions.api.selectNode(node, true);
                        this.gridOptions.api.ensureNodeVisible(node, "middle")
                    }
                });

            }

        }, 500);

    }
    public customCellRendererFuncSkadetyp(params): string {

        var status = params.context.componentParent.getSkadeTypeName(params.data.Skadetyp);

        return status;
    };
    public customCellRendererFuncStatus(params): string {

        var status = params.data.Status;

        switch (status) {
            case 0:
                status = "Open";
                break;
            case 1:
                status = "Closed";
                break;
        }

        var ttt = '<label style="padding:0px;margin:0px;"">' + status + '</label>';
        return ttt;
    };
    public customCellRendererFunc(params): string {

        var status = params.data.AccidentType;

        switch (status) {
            case 0:
                status = "Incident";
                break;
            case 1:
                status = "Personskada";
                break;
            case 2:
                status = "Fastighetsskada";
                break;
        }

        var ttt = status;
        return ttt;
    };
    dateFormatterRemindDate(params) {

        var date = params.context.componentParent.getDate(params.data.Date, params.data.Time);
        var timezone = params.context.componentParent.timezone;
        var offset = moment.tz(timezone.slice(12)).format('Z');

        var offsetNumber = +offset.split(':')[0];

        var test = moment(date).add(offsetNumber, "hours").format('YYYY-MM-DD HH:mm');
        return moment(date).add(offsetNumber, "hours").format('YYYY-MM-DD HH:mm');


        // return moment(date).format('YYYY-MM-DD')

    }
    @ViewChild('content') content: TemplateRef<any>;
    public customCellRendererFuncAction(params) {

        var eDiv = document.createElement('div');
        //<button class="edit">Edit</button></span>1
        // <a><i class='success fa fa-eye edit3'></i></a> &nbsp;
        eDiv.innerHTML = "<span class='my-css-class'><a><i style='color:#ffc107' class='fa fa-pencil edit'></i></a> &nbsp; <a><i style='color:red' class='fa fa-trash edit1'></i></a> &nbsp; </span>";


        var eButton = eDiv.querySelectorAll('.edit')[0];
        eButton.addEventListener('click', function() {
            params.context.componentParent.editItem(params.data.Id, params.rowIndex);
            // 

        });

        var eButton2 = eDiv.querySelectorAll('.edit1')[0];
        eButton2.addEventListener('click', function() {
            params.context.componentParent.openLg(params.context.componentParent.content, params.data);//openLg(params.context.componentParent.content,params.data)
        });

        return eDiv;

    };

    public customCellRendererFuncDate(params) {

        var eDiv = document.createElement('div');

        return eDiv;

    };

    public loadDataById(selectedDate, toDate, accidentType, siteid, typeData, searchText, status) {
        this.gridApi.showLoadingOverlay();
        this.accidentTypeSelected = accidentType;
        this.showSpinner = true;
        var stringDay = selectedDate.year + "-" + selectedDate.month + "-" + selectedDate.day;

        var toDayString = toDate.year + "-" + toDate.month + "-" + toDate.day;
        this.SiteId = siteid;
        this.SiteId$.next(this.SiteId);
        var user = JSON.parse(localStorage.getItem('currentUser'));
        this.incidentAccidentService.GetAll(stringDay, toDayString, accidentType, siteid, typeData, searchText, status, user.accountId, user.id, this.moduleId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData = response.Data;
                this.totalItems = response.Data.length;

                AgGridUtils.showColumn(!!!this.SiteId, this.gridColumnApi, "SiteName");

                this.scrollToId();
            });
    }

    public loadRole() {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.getRole(currentUser.id, this.moduleId, this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.role = response.Data;

            });

    }

    editItem(id: number, rowIndex = 0) {
        // 


        //this.router.navigate([`incident-accident/${id}/edit`]); 


        const modalRef = this.modalService.open(IncidentAccidentEditComponent, modalMyClass);
        var selectedRows = this.gridApi.getSelectedRows();
        localStorage.setItem('selectedRowIncidentAccident', id.toString());
        localStorage.setItem('ScrollToId', rowIndex.toString());
        modalRef.componentInstance.IncidentAccidentId = id;
        //modalRef.componentInstance.SiteId = siteId;  
        modalRef.result.then((result) => {
            this.DeleteData.emit({ Data: "" });
        }, (reason) => {
            this.DeleteData.emit({ Data: "" });
        });

    }

    getDate(date: NgbDateStruct, time: NgbTimeStruct) {
        return new Date(date.year, date.month - 1, date.day, time.hour, time.minute, time.second);
    }

    getSkadeTypeName(skadetyp: number) {

        if (skadetyp == 0) {
            return "";
        } else {
            if (this.skadetypes.length != 0) {
                return this.skadetypes.filter(x => x.Id == skadetyp)[0].Name;
            }
            return "";
        }
    }

    loadSkadetypes() {

        var user = JSON.parse(localStorage.getItem('currentUser'));
        this.incidentAccidentService.GetAllSkadetype(user.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.skadetypes = response.Data;

            });

    }

    openLg(content, id) {
        this.deleteId = id;
        this.modalReference = this.modalService.open(content);
    }

    deleteData(deleteId: number) {
        this.incidentAccidentService.deleteData(deleteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.modalReference.close();
                this.DeleteData.emit({ Data: "" });

            });
    }

    public customCellRendererFuncActionStatus(params) {
        var eDiv = document.createElement("div");
        //<button class="edit">Edit</button></span>1
        // <a><i class='success fa fa-eye edit3'></i></a> &nbsp;
        var status = "";
        switch (params.data.Status) {
            case 1:
                status = "green";
                eDiv.innerHTML =
                    "<div style='margin:auto;height:15px;margin-top:5px; width: 15px; background-color:" +
                    status +
                    "'></div>";
                break;
            case 0:
                status = "red";
                eDiv.innerHTML =
                    "<div style='margin:auto;height:15px;margin-top:5px; width: 15px; background-color:" +
                    status +
                    "'></div>";
                break;
        }
        return eDiv;
    }
}



// WEBPACK FOOTER //
// ./src/app/incident-accident/components/incident-accident-list/incident-accident-list.component.ts